import EmptyState from "../components/EmptyState";
import Timeline from "../components/Timeline";
import { formatMonthYear, sortNewestFirst } from "../profileUtils";
import ui from "../../../components/ui/ui.module.css";

const EmploymentHistorySection = ({ history }) => {
  if (!history.length) return <EmptyState />;

  const items = sortNewestFirst(history, (h) => h.startDate).map((h) => ({
    key: h.id,
    period: [
      formatMonthYear(h.startDate),
      h.endDate ? formatMonthYear(h.endDate) : "present",
    ]
      .filter(Boolean)
      .join(" – "),
    title: [h.position, h.companyName].filter(Boolean).join(" · "),
    body: (
      <>
        {h.employeeType && <div>{h.employeeType}</div>}
        {h.companyAddress && <div className={ui.muted}>{h.companyAddress}</div>}
        {h.reasonForLeaving && (
          <div>Reason for leaving: {h.reasonForLeaving}</div>
        )}
      </>
    ),
  }));

  return <Timeline items={items} />;
};

export default EmploymentHistorySection;
